<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Дизайн карты

  .container.mt-5
    .row
      .col-12
        h2 Редактирование карт
          button.addDesign(@click="addDesign()")
            i.fal.fa-plus-circle
      .col-sm-5(v-if="loading")
        object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
      .col-sm-5.white_block.design(
        v-for="design in designs",
        :class="{ minified: design.minified }"
      )
        .card_preview(
          :style="{ backgroundColor: design.background_color, color: design.value_color }",
          @click="design.minified = false"
        )
          .backgroundImage(
            :style="{ backgroundImage: 'url(' + design.strip + ')', backgroundPosition: 'center', backgroundSize: '1000px' }"
          )
          .card_name {{ design.name }}
        .loading(v-if="design.loading")
          object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
        .loaded(v-if="!design.loading")
          //- h4 Дизайн карты №{{design.number}}
          .copy(@click="addDesign(design)")
            i.far.fa-copy
          .minify(@click="design.minified = true")
            i.fas.fa-minus
          .card_title
            input-module(type="title-text", v-model="design.name")
          .inputModule
            input-module(
              type="text",
              title="Текст на логотипе",
              v-model="design.logo_text"
            )
          .inputModule
            input-module(
              type="text",
              title="Описание карты",
              v-model="design.description"
            )
          .inputModule
            input-module(
              type="color",
              title="Общий заполняющий задний фон карты",
              v-model="design.background_color"
            )
          .inputModule
            input-module(
              type="color",
              title="Цвет текста названия значения",
              v-model="design.label_color",
              about="Это цвет слова, например, Бонусы"
            )
          .inputModule
            input-module(
              type="color",
              title="Цвет текста значения",
              v-model="design.value_color",
              about="Это цвет значения, например, 500.00"
            )
          .inputModule
            input-module(
              type="image",
              title="Иконка пуша",
              layout="square",
              v-model="design.icon",
              about="Мы рекомендуем изображение размером 64х64"
            )
          .inputModule
            input-module(
              type="image",
              title="Логотип карты (распологается слева сверху)",
              v-model="design.logo",
              about="Мы рекомендуем изображение размером 142х142 или 142x300"
            )
          .inputModule
            input-module(
              type="image",
              title="Изображение поперёк карты (Стрип)",
              v-model="design.strip",
              about="Мы рекомендуем изображение размером 800x200",
              :links="[ { href: 'https://storage.yandexcloud.net/actid-storage/actid-cards-core-assets/strip.psd', text: 'Скачайте шаблон стрипа' }, { href: 'https://storage.yandexcloud.net/actid-storage/actid-cards-core-assets/card.psd', text: 'Скачайте шаблон дизайна целой карты' }, ]"
            )
          .inputModule
            input-module(
              type="cards-content-secondary",
              title="Поля карты спереди",
              v-model="design.content"
            )
          .inputModule
            input-module(
              type="cards-content",
              title="Контент карты сзади",
              v-model="design.content.backFields"
            )
          .inputModule
            input-module(
              type="cards-geofences",
              title="Геопуши",
              v-model="design.geo_fences",
              about="Для того, чтобы найти широту и долготу, перейдите на любой сервис карт, укажите точку и надите 2 значения с цифрами, где первое - широта, а второе - долгота.",
              @change="updateGeoCollection",
              :collection="geocollection"
            )
          hr
          button.styled.card_design_save(v-on:click="saveDesign(design)") Сохранить
          button.styled.card_design_remove(
            v-on:click="removeDesign(design)",
            :disabled="designs.length <= 1"
          ) Удалить
          button.styled.card_design_apply(
            v-on:click="applyDesign(design)",
            :disabled="!design.ready_to_apply_to_card"
          ) Применить к картам

  .container(style="margin-top: 100px")
    .row
      .col-12
        h2 Соединение дизайна с группой
    .row
      .white_block(style="padding-top: 20px; padding-bottom: 20px")
        .col-12.design_connection(
          v-for="teplateToGroup of teplateToGroups",
          style="margin-bottom: 5px"
        )
          span Дизайн карты
          select(
            v-model="teplateToGroup.template_id",
            :disabled="teplateToGroup.waitingForConfirm || groups.length == 0",
            v-on:change="updateTemplateToGroup(teplateToGroup)"
          )
            option(v-for="design of designs", :value="design.id") {{ design.name }}
          |
          | к
          span(style="margin-left: 5px") группе
          select(
            v-model="teplateToGroup.group_identifier",
            :disabled="teplateToGroup.waitingForConfirm || groups.length == 0",
            v-on:change="updateTemplateToGroup(teplateToGroup)"
          )
            option(v-for="group of groups", :value="group.client_group_id") {{ group.client_group_name }}
          button.removeTemplateToGroup(
            v-on:click="removeTemplateToGroup(teplateToGroup)",
            :disabled="teplateToGroup.waitingForConfirm || groups.length == 0"
          )
            i.fal.fa-times
        .col-12
          br
          button.styled(
            v-on:click="createTemplateToGroup()",
            :disabled="groups.length == 0"
          ) + Добавить привязку
          br
        .col-12(style="margin-top: 10px; font-size: 10pt; color: gray") Управлять группами Вы можете в личном кабинете своей POS-системы.
</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      designs: [],
      teplateToGroups: [],
      groups: [],
      geocollection: [],
      loading: true,
    };
  },

  computed: {},

  mounted() {
    this.loadCardTemplates();
    this.loadTemplateToGroups();
    this.loadUserGroups();
  },

  methods: {
    updateGeoCollection() {
      let gc = [];
      for (let d of this.designs) {
        if (!d.geo_fences) continue;
        for (let f of d.geo_fences) {
          if (
            gc.find(
              (x) =>
                x.latitude == f.latitude &&
                x.longitude == f.longitude &&
                x.relevantText == f.relevantText
            )
          )
            continue;
          gc.push(f);
        }
      }
      this.geocollection = gc;
      // this.$forceUpdate();
    },
    async handleImageUpload(e, model, text_key) {
      let img = e.target.files[0];
      model[text_key] = "Загрузка...";
      let formData = new FormData();
      formData.append("file", img);
      let upload = await apiDriver.upload.image(formData);
      if (!upload) {
        model[text_key] = "Произошла ошибка.";
        return;
      }
      model[text_key] = upload.upload.Location;
    },
    async loadCardTemplates() {
      this.loading = true;
      let x = (
        await apiDriver.services.api.get("cards", "settings/userCardTemplates")
      ).data;
      for (let d of x.templates) d.minified = true;
      this.designs = x.templates;
      this.updateDesignVirtualNumbers();
      this.updateGeoCollection();
      this.loading = false;
    },
    updateDesignVirtualNumbers() {
      let i = 1;
      for (let d of this.designs) {
        d.number = i;
        i++;
      }
    },
    async addDesign(d) {
      let new_design = JSON.parse(
        JSON.stringify(d ? d : this.designs[this.designs.length - 1])
      );
      new_design.loading = true;
      new_design.id = -1 * parseInt(Math.random() * 9999999);
      this.designs.push(new_design);
      this.$forceUpdate();
      this.updateDesignVirtualNumbers();
      let model_copy = JSON.parse(JSON.stringify(new_design));
      delete model_copy.loading;
      delete model_copy.number;
      delete model_copy.minified;
      let x = (
        await apiDriver.services.api.post(
          "cards",
          "settings/createCardTemplate",
          model_copy
        )
      ).data;
      let _design = this.designs.find((x) => x.id == new_design.id);
      _design.loading = false;
      _design.id = x.created.created.id;
      console.log("created:", x);
    },
    async saveDesign(model) {
      this.$toast.success("Дизайн успешно сохранён!");
      let model_copy = JSON.parse(JSON.stringify(model));
      delete model_copy.loading;
      delete model_copy.number;
      delete model_copy.ready_to_apply_to_card;
      let x = (
        await apiDriver.services.api.post(
          "cards",
          "settings/saveCardTemplate",
          model_copy
        )
      ).data;
      model.ready_to_apply_to_card = true;
      this.$forceUpdate();
    },
    async applyDesign(model) {
      this.$toast.success(
        "Карты с эти дизайном буду обновлены в течение 10 минут..."
      );
      let model_copy = JSON.parse(JSON.stringify(model));
      delete model_copy.loading;
      delete model_copy.number;
      delete model_copy.ready_to_apply_to_card;
      model.ready_to_apply_to_card = false;
      this.$forceUpdate();
      let x = (
        await apiDriver.services.api.post(
          "cards",
          "settings/applyCardTemplate",
          model_copy
        )
      ).data;
    },
    async removeDesign(model) {
      let model_copy = JSON.parse(JSON.stringify(model));
      delete model_copy.loading;
      delete model_copy.number;
      this.designs = this.designs.filter((x) => x.id != model.id);
      let x = (
        await apiDriver.services.api.post(
          "cards",
          "settings/removeCardTemplate",
          model_copy
        )
      ).data;
      for (let ttg of this.teplateToGroups) {
        if (ttg.template_id == model_copy.id) this.removeTemplateToGroup(ttg);
      }
    },
    async loadTemplateToGroups() {
      let x = (
        await apiDriver.services.api.get("cards", "settings/teplateToGroups")
      ).data;
      this.teplateToGroups = x.templates;
    },
    async loadUserGroups() {
      let x = (
        await apiDriver.services.api.get("cards", "settings/getAllPosGroups")
      ).data;
      console.log(x.groups);
      this.groups = x.groups;
    },
    async createTemplateToGroup() {
      let n = {
        template_id: this.designs[0].id,
        group_identifier: this.groups[0].client_group_id,
        waitingForConfirm: true,
        id: -1 * Math.random(),
      };
      this.teplateToGroups.push(n);
      let x = (
        await apiDriver.services.api.post(
          "cards",
          "settings/createTeplateToGroups",
          n
        )
      ).data;
      let temp_group = this.teplateToGroups.find((x) => x.id == n.id);
      temp_group.waitingForConfirm = false;
      temp_group.id = x.created.id;
      console.log("createTemplateToGroup:", x);
    },
    async removeTemplateToGroup(teplateToGroup) {
      if (this.teplateToGroups.length == 1) return;
      if (teplateToGroup.waitingForConfirm == true) return;
      teplateToGroup.waitingForConfirm = true;
      let x = (
        await apiDriver.services.api.post(
          "cards",
          "settings/removeTeplateToGroups",
          { id: teplateToGroup.id }
        )
      ).data;
      this.teplateToGroups = this.teplateToGroups.filter(
        (x) => x.id !== teplateToGroup.id
      );
      console.log("removeTemplateToGroup:", x);
    },
    async updateTemplateToGroup(teplateToGroup) {
      if (teplateToGroup.waitingForConfirm == true) return;
      teplateToGroup.waitingForConfirm = true;
      await apiDriver.services.api.post(
        "cards",
        "settings/updateTeplateToGroups",
        teplateToGroup
      );
      teplateToGroup.waitingForConfirm = false;
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.addDesign {
  border: none;
  background: none;
  font-size: 17pt;
  margin-left: 10px;
  position: relative;
  top: -2px;
  opacity: 0.5;
  cursor: pointer;
  outline: none;

  &:hover {
    opacity: 1;
  }

  &[disabled] {
    opacity: 0.3;
    cursor: default;
  }
}

.design {
  transition: 0.5s all;

  // max-height: 3500px;
  .card_preview {
    transition: 0.5s all;
    position: absolute;
    top: 0px;
    z-index: 2;
    cursor: pointer;
    width: 100%;
    height: 0px;
    left: 0;
    overflow: hidden;

    .backgroundImage {
      position: absolute;
      top: 0;
      left: 0;
      filter: blur(15px);
      height: 100%;
      width: 100%;
      opacity: 0.5;
      cursor: pointer;
    }

    .card_name {
      font-size: 20pt;
      margin: 30px;
      margin-left: 40px;
      cursor: pointer;
      z-index: 2;
      position: absolute;
    }
  }

  &.minified {
    max-height: 200px;
    overflow: hidden;

    .card_preview {
      top: 0;
      height: 200px;
    }
  }

  .minify {
    position: absolute;
    right: 20px;
    top: 10px;
    z-index: 1;
    opacity: 0.5;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }

  .copy {
    position: absolute;
    right: 45px;
    top: 10px;
    z-index: 1;
    cursor: pointer;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }

  // background: white;
  // padding-bottom: 10px;
  .card_title {
    margin-top: 10px;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
  }

  h4 {
    margin-top: 0;
  }

  button.card_design_apply {
    float: right;
  }

  button.card_design_remove {
    margin-left: 5px;
    border: 1px solid #f44336;
    color: #f44336;

    &:hover {
      background: #f44336;
      color: white;
    }
  }

  button.card_design_save {
    border: 1px solid #4caf50;
    color: #4caf50;

    &:hover {
      background: #4caf50;
      color: white;
    }
  }
}

.inputModule {
  margin-bottom: 10px;
}

.removeTemplateToGroup {
  border: none;
  background: none;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }

  &[disabled] {
    opacity: 0.3;
    cursor: default;
  }
}

select {
  margin: 0 5px;
}

@media only screen and (max-width: 600px) {
  .card_design_save {
    width: calc(100% - 100px);
  }

  .card_design_remove {
    float: right;
  }

  .card_design_apply {
    width: 100%;
    margin-top: 10px;
  }

  .design_connection {
    padding: 10px 0;

    span {
      display: none;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .addDesign {
    color: white;
  }

  .design button.card_design_save {
    color: white;
    background: #4caf50;

    &:hover {
      background: #5ed563;
    }
  }

  .design button.card_design_remove {
    color: white;
    background: #f44336;

    &:hover {
      background: #f95c51;
    }
  }

  .removeTemplateToGroup {
    color: white;
  }
}
</style>
